import { useContext, useState } from 'react'
import { Box, Button, Container, Grid, Stack, Typography } from '@mui/material'
import { AuthContext, Field, Form } from '@wolfdanepug/common-react'
import Logo from '../../components/Header/Logo'

export default function Login() {
	const [email, setEmail] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const { authenticate } = useContext(AuthContext)

	const handleFormSubmit = async (e: any) => {
		e.preventDefault()
		await authenticate({ email, password }, '/')
	}

	return (
		<Container maxWidth="lg">
			<Stack
				sx={{
					flexDirection: 'column',
					flex: 1,
					height: '100%',
					justifyContent: 'center',
					alignItems: {
						xs: 'center',
						md: 'flex-start'
					}
				}}
			>
				<Box sx={{ display: 'flex', mb: 5 }}>
					<Logo width={185} sx={{ root: { zIndex: 1102 }, imageWrap: { position: 'relative' } }} />
				</Box>
				<Form onSubmit={handleFormSubmit} sx={styles.form}>
					<Grid container spacing={2}>
						<Grid item md={6}>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<Typography variant="h2">Member Login</Typography>
								</Grid>
								<Grid item xs={12}>
									<Field
										type="email"
										name="email"
										placeholder="Email"
										required
										sx={styles.input}
										value={email}
										onChange={(e: any) => setEmail(e.target.value)}
									/>
								</Grid>
								<Grid item xs={12}>
									<Field
										type="password"
										name="password"
										placeholder="Password"
										value={password}
										onChange={(e: any) => setPassword(e.target.value)}
										required
										sx={styles.input}
									/>
								</Grid>
								{/* <div>{errorMessage && <p>{errorMessage}</p>}</div> */}
								<Grid item xs={12}>
									<Stack direction="row" justifyContent="space-between">
										<Button variant="contained" type="submit" size="large">
											Login
										</Button>
										{/* <Button LinkComponent={Link} href="/forgot-password" size="small">
							Forgot Password
						</Button> */}
									</Stack>
								</Grid>
							</Grid>
						</Grid>
						<Grid item md={6}></Grid>
					</Grid>
				</Form>
			</Stack>
		</Container>
	)
}

const styles = {
	form: {
		width: '100%',
		root: {
			// p: {
			// 	xs: 5,
			// 	md: 0
			// }
		}
	},
	input: {
		field: {
			'& .MuiInputBase-input': {
				backgroundColor: '#fff',
				borderRadius: 1
			}
		}
	}
}
